import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "bus" | "people";

interface IState {
  visible: boolean;
  cameraTypes: any[];
  markerMode: SelectingType[];
  heatmapMode: SelectingType;
  pointwiseShow: boolean;
  loading: boolean;
  type: Type;
  selectedCamera: any[];
  cameraStarTypes: any[];
  cameraShowType: string[];
}

const initialState: IState = {
  visible: false,
  cameraTypes: [],
  markerMode: ["source"],
  heatmapMode: "source",
  pointwiseShow: false,
  loading: false,
  type: "people",
  selectedCamera: [],
  cameraStarTypes: [],
  cameraShowType: ["1"],
};

export const cameraSlice = createSlice({
  name: "camera",
  initialState,
  reducers: {
    changeCameraType: (state, action: PayloadAction<any>) => {
      if (state.cameraTypes.includes(action.payload)) {
        return { ...state, cameraTypes: state.cameraTypes.filter((c) => c !== action.payload) };
      }
      return { ...state, cameraTypes: [...state.cameraTypes, action.payload] };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    togglePointwiseShow: (state) => {
      return { ...state, pointwiseShow: !state.pointwiseShow };
    },
    changeLoadingMode: (state, action: PayloadAction<boolean>) => {
      return { ...state, loading: action.payload };
    },
    selectCamera: (state, action: PayloadAction<any[]>) => {
      return { ...state, selectedCamera: action.payload };
    },
    changeCameraStarTypes: (state, action: PayloadAction<any[]>) => {
      return { ...state, cameraStarTypes: action.payload };
    },
    changeCameraShowType: (state, action: PayloadAction<string[]>) => {
      return { ...state, cameraShowType: action.payload };
    },
  },
});

export const {
  changeCameraType,
  toggleVisibility,
  makeInvisible,
  togglePointwiseShow,
  changeLoadingMode,
  selectCamera,
  changeCameraStarTypes,
  changeCameraShowType,
} = cameraSlice.actions;

export default cameraSlice.reducer;
